// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const stringifyWithoutQuoteOnKey = (json: any): string => {
  if (typeof json !== 'object') {
    return JSON.stringify(json);
  } else if (Array.isArray(json)) {
    return `[${json.map(x => stringifyWithoutQuoteOnKey(x)).join(',')}]`;
  }

  const props: string = Object.keys(json)
    .map(key => `${key}: ${stringifyWithoutQuoteOnKey(json[key])}`)
    .join(',');
  return `{${props}}`;
};

const getProxyAgentFromOpener = (): {
  sessionId: string;
  charged: boolean;
} | null => {
  try {
    return window.opener?.proxyAgent;
  } catch (_) {
    return null;
  }
};

const getProxyAgentFromName = (): {
  sessionId: string;
  charged: boolean;
} | null => {
  try {
    return JSON.parse(window.name);
  } catch (_) {
    return null;
  }
};

export const getProxyAgent = (): {
  sessionId: string;
  charged: boolean;
} | null => {
  return getProxyAgentFromOpener() ?? getProxyAgentFromName();
};
